'use client';
import dynamic from 'next/dynamic';

// The modal is rendered hidden (open/close controlled by
// useProductBlockAsideModal hook), so its JS chunk doesn't need to be in the
// initial bundle. ssr: true keeps the markup in server HTML for SEO.
//
// The hook is re-exported eagerly from its own module — consumers that only
// open the modal (no rendering) don't pull the modal's chunk.
const ProductBlockAsideModalLazy = dynamic(
  () =>
    import('./ProductBlockAsideModal').then((m) => ({
      default: m.ProductBlockAsideModal,
    })),
  { ssr: true },
);

export { ProductBlockAsideModalLazy as ProductBlockAsideModal };
export {
  useProductBlockAsideModal,
  type ProductBlockAsideModalState,
} from './useProductBlockAsideModal';
